// extracted by mini-css-extract-plugin
module.exports = {"scoreInput":"ScoreInput_scoreInput__1su-d","dash":"ScoreInput_dash__rRSqT"};